module.exports = __webpack_public_path__ + "img/guilin.ccdcf1f8.png";